import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import Header from 'src/components/Header';
import Layout from 'src/components/Layout';
import Footer from 'src/components/Footer';
import { HeadingScope } from 'src/components/Heading';

interface DataProtectionProps {
  data: any;
}

const DataProtection: FC<DataProtectionProps> = ({ data }) => {
  const { body } = data.content;

  return (
    <HeadingScope>
      <Header isWhite />
      <Layout layout="Inner-page">
        <MDXRenderer>{body}</MDXRenderer>
      </Layout>
      <Footer />
    </HeadingScope>
  );
};

export default DataProtection;

export const query = graphql`
  query DataProtection {
    content: mdx(slug: { eq: "data-protection/" }) {
      body
    }
  }
`;
